import Navigation from "./navigation";

export default function() {
  const nav = new Navigation();
  nav.init()
  return nav;
}
